import { render } from "./GenerateMissingPkg.vue?vue&type=template&id=28d04a68&scoped=true"
import script from "./GenerateMissingPkg.vue?vue&type=script&lang=js"
export * from "./GenerateMissingPkg.vue?vue&type=script&lang=js"

import "./GenerateMissingPkg.vue?vue&type=style&index=0&id=28d04a68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d04a68"]])

export default __exports__